import { Timeline as MantineTimeline, TimelineProps } from '@mantine/core';

export type ITimelineProps = TimelineProps;

/** @registry Design-layer pass-through over Mantine Timeline; import this instead of @mantine/core Timeline outside src/design. Extend here when Timeline needs house behavior. Compound statics (Timeline.Item) are preserved. */
export const Timeline = MantineTimeline;
